<template>
  <div class="section-white" >
    <div  class="clearfix" style="margin: 30rpx auto;">
      <span>预存款余额: <span style="color:firebrick;">{{amount}}</span> 元</span>
    </div>
    <div class="record-list">
      <el-table :data="recordList" @filter-change="filterTag" border v-loading="loading">
         <el-table-column prop="memo" label="摘要"></el-table-column>
         <el-table-column prop="message" label="备注"></el-table-column>
         <el-table-column prop="money" label="剩余余额/元"></el-table-column>
         <el-table-column prop="money" label="交易金额/元">
          <template slot-scope="scope">
             <span v-if="scope.row.explode_money ==0 " style="color:red">
              {{scope.row.import_money}}
             </span>
             <span  style="color:green"  v-else>
                 -{{scope.row.explode_money}}
             </span>
           </template>
         </el-table-column>
         <el-table-column prop="mtime" label="交易时间"></el-table-column>
         <el-table-column prop="order_id" label="订单ID"></el-table-column>
         <el-table-column prop="payment_id" label="交易ID"></el-table-column>
         <el-table-column prop="paymethod" label="交易方式"></el-table-column>
         <el-table-column prop="store" label="店铺"></el-table-column>
      </el-table>
    </div>
    <div v-if="total_count > params.pageSize"  class="content-padded tc">
 <el-pagination background layout="total, sizes, prev, pager, next" @current-change="handleCurrentChange"
           @size-change="handleSizeChange" :current-page.sync="params.page" :page-sizes="[20, 50,100,200]"
           :total="total_count" :page-size="params.pageSize">
         </el-pagination>
    </div>
  </div>
</template>

<script>

import { getUserNpDepositList } from '../../../api/deposit'
export default {
  props: ['userId', 'isLoad'],
  data () {
    return {
      loading: false,
      trade_type: '',
      total_count: 0,
      pageSize:20,
      recordList: [],
      typeFilters: [
        { text: '充值记录', value: 'recharge' },
        { text: '赠送记录', value: 'recharge_gift' },
        { text: '消费记录', value: 'consume' },
        { text: '返佣记录', value: 'recharge_send' }
      ],
      params: {
        page: 1,
        pageSize: 20,
      },
      date_begin: '',
      date_end: '',
      amount:'',
      form:{
        amount:0,
        memo:'',
      },
      isdisabled:false,
    }
  },
  methods: {
 handleSizeChange(pageSize) {
      this.params.page = val;
      this.params.member_id = this.userId
      this.getList(this.params)
    },
    handleCurrentChange (val) {
      this.params.page = val
      this.params.member_id = this.userId
      this.getList(this.params)
    },
    getList (query) {
      this.loading = true
      getUserNpDepositList(query).then(res => {
        this.recordList = res.data.data.list;
        this.amount = res.data.data.amount;
        this.total_count = parseInt(res.data.data.total_count);
        this.loading = false
      })
    },

    dateStrToTimeStamp (str) {
      return Date.parse(new Date(str))/1000
    }
  },

  mounted () {
    // let query = {pageSize: this.pageSize, page: 1}
    // this.getList(query)
  },
  watch: {
    userId (newVal, oldVal) {
      if (this.isLoad) {
        let query = {pageSize: 20, page: 1, member_id: newVal}
        this.getList(query);

      }
    },
    isLoad (newVal, oldVal) {
      if (newVal) {
        let query = {pageSize: 20, page: 1, member_id: this.userId}
        this.getList(query);

      }
    }
  }
}
</script>
<style type="text/css">
  .record-list .el-table .cell, .record-list .el-table th > div {
    padding-left: 10px;
    padding-right: 10px;
  }
</style>



// WEBPACK FOOTER //
// npdepositlist.vue?725fadea